const name = 'Boaz Kaufman';
const role = 'Assistant Product Manager';
const text = `Boaz Kaufman graduated Magna Cum Laude from Hunter College
with a B.A. in Computer Science. After undergrad, Boaz was a cyber incident response intern for the NYC Department of Education and is currently completing the Masters of Information and Cybersecurity program at UC Berkeley's School of Information.`;

const boazKaufman = { name, role, text };

export default boazKaufman;
